import ErrorHandler from "@/utils/errorHandler";

export class Config {
  /**
   * 获取分辨率比例
   * @param sdkContent
   * @returns
   */
  static getResolutionRatioList(sdkContent: any) {
    const configResp = sdkContent.getConfigService().getResolutionRatioMap();
    const ratioList = Array.from(configResp.asJsReadonlyMapView().values());
    return ratioList;
  }

  /**
   * 获取字幕配置列表
   * @param sdkContent
   * @returns
   */
  //   static async getSubtitleList(sdkContent: any) {
  //     try {
  //       const subtitleList: any;
  //       console.log("subtitleList", subtitleList);
  //       return subtitleList;
  //     } catch (exception) {
  //       ErrorHandler.handleSDKError(exception);
  //     }
  //   }

  /**
   * 获取预设的问题列表
   * @param sdkContent
   * @returns
   */
  static async getPresetIssueInfo(sdkContent: any) {
    try {
      const feedbackInfoResp: any = await new Promise((resolve, reject) => {
        sdkContent.getFeedbackService().queryPresetIssueList().proceedWithCallback({
          onSuccess: resolve,
          onFail: reject,
        });
      });
      return feedbackInfoResp;
    } catch (exception: any) {
      ErrorHandler.handleSDKError(exception);
      return {};
    }
  }

  /**
   * 获取购买配置
   * @param sdkContent
   * @returns
   */
  static async getPurchaseConfig(sdkContent: any) {
    const purchaseConfigResp = sdkContent.getConfigService().queryPurchaseConfig();
    return purchaseConfigResp;
  }

  /**
   * 获取套餐信息列表
   * @param sdkContent
   * @returns
   */
  static getPackageInfoList(sdkContent: any) {
    const packageInfoListResp = sdkContent.getConfigService().getPackageInfoList();
    return packageInfoListResp.asJsArrayView();
  }

  /**
   * 获取正则表达式
   * @param sdkContent
   * @returns
   */
  static getRegex(sdkContent: any) {
    const regexResp = sdkContent.getConfigService().queryValidationConfig();
    return regexResp;
  }

  /**
   * 获取 Fairplay 证书下载地址
   * @param sdkContent
   * @returns
   */
  static getFairPlayLicenseUrl(sdkContent: any) {
    const getFairPlayLicenseUrl = sdkContent.getConfigService().getFairPlayLicenseUrl();
    return getFairPlayLicenseUrl;
  }
}
